import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  // Check if user is authenticated
  if (!user.id) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if user is admin
  if (!user.is_admin) {
    return <Navigate to="/lessons" replace />;
  }
  
  return children;
};

export default AdminRoute; 